<template>
    <div>
        <div style="height:20px;"></div>

        <Results_Biomarkers></Results_Biomarkers>

        <div style="text-align:left;">
            <v-btn color="info">
                Single Nucleotide Variants (SNVs)
                ({{ Object.keys(this.$store.getters.id_snvs).length }})
            </v-btn>
            <div style="height:20px;"></div>
        </div>
        <Patient_SNV_Table></Patient_SNV_Table>

        <div style="height:20px"></div>

        <div style="text-align:left;">
            <v-btn color="info">
                Gene Fusions
                ({{ Object.keys(this.$store.getters.id_fusions).length }})
            </v-btn>
            <div style="height:20px;"></div>
        </div>
        <Fusion_Table></Fusion_Table>

        <!-- Unidentified mutations -->
        <div style="text-align:left;">
            <v-btn color="info">
                Unidentified ({{ Object.keys(this.$store.getters.id_unidentified).length }})
            </v-btn>
            <div style="height:20px;"></div>
            <v-table class="elevation-1 table table-striped tb-variants">
                <thead>
                    <tr>
                        <td>Genomic location</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item,k) in this.$store.getters.id_unidentified"  v-bind:key="k">
                        <td>{{ k }}</td>
                    </tr>
                </tbody>
            </v-table>
        </div>

<!--{{ this.$store.getters.snvs }}-->
<!--{{ this.$store.getters.id_variants }}-->

<Loading v-model:active="isLoading" v-model="fullPage"
    :can-cancel="true"
    :is-full-page="fullPage" />
    </div>
</template>
<script>
import Loading from 'vue-loading-overlay';
import Fusion_Table from '@/components/tables_native/Fusion_Table';
import Patient_SNV_Table from '@/components/tables_native/Patient_SNV_Table';
import Results_Biomarkers from "@/components/query_result_components/Results_Biomarkers.vue";
import variant_annotation from "@/methods/variant_annotation";

export default {
    data () {
      return {
        headers: [
        ],
        revel_key: 0,
        revel_colour:"#00b0d2",
        agg_interpret_data: '',
        sortStates: {
            'gene_name': 0,
            'variant_exchange': 0
        },
        iconStatesUp: {
            'gene_name' : 'mdi-arrow-up-thin',
            'variant_exchange' : 'mdi-arrow-up-thin'
        },
        iconStatesDn: {
            'gene_name' : 'mdi-arrow-down-thin',
            'variant_exchange' : 'mdi-arrow-down-thin'
        },
        isLoading: false,
        fullPage: true,
      }
    },
    components: {
        Loading,
        Fusion_Table,
        Patient_SNV_Table,
        Results_Biomarkers,
    },
    created: async function() {
        //this.isFusionQuery(this.$route.query.q)
    },
    methods: {
        generateGeneNameLocations() {
            for (let key in this.$store.getters.id_variants) {
                let gene_name = this.$store.getters.id_variants[key]["UTA_Adapter"]["gene_name"] + ":" + this.$store.getters.id_variants[key]["UTA_Adapter"]["variant_exchange"]
                this.$store.dispatch('setGeneNameLoc',[gene_name,key])
                //alert(gene_name + ":" +key)
            }
        },
        rerender() {
        },
        getClinVarColor(estim) {
            if (estim =='') {
                return "white"
            }
            else if (estim == 'Benign/Likely benign') {
                return "#4cb1d1"
            }
            else if (estim == 'Likely pathogenic') {
                return "#df6464"
            }
            else if (estim == 'Pathogenic/Likely pathogenic') {
                return "#b53636"
            }
            else if (estim == 'Pathogenic| drug response| other') {
                return "#8b5454"
            }
            else if (estim == 'Conflicting interpretations of pathogenicity') {
                return "#6f6f6f"
            } else {
                return "grey"
            }
        },
        getBarColour(val) {
            if (val < 50) {
                return "#00b0d2"
            } else {
                return "#ce8585"
            }
        },
        showLoadingSpinner() {
        },
    },
    beforeCreate: async function() {
        //this.$store.dispatch('setVariants',[])
    },
    created: async function() {
        this.$store.dispatch('setBackRef',this.$route.fullPath)
    },
    mounted: async function() {
        this.$store.dispatch('setIdData',this.$route.params.id)

        if (this.$route.query.q) {
            // Check if data has already been loaded
            let perform_query = true
            this.$store.dispatch('setIdSNVs',{})
            this.$store.dispatch('setIdIns',{})
            this.$store.dispatch('setIdDels',{})
            this.$store.dispatch('setIdCNVs',{})
            this.$store.dispatch('setIdFusions',{})

            if (this.$store.getters.id_variants) {
                if (Object.keys( this.$store.getters.id_variants ).length > 0) {
                    if (this.$store.getters.query) {
                        if (this.$store.getters.query == this.$route.query.q) {
                            perform_query = false
                        }
                    }
                }
            } else {
            }

            // Manual variant search
            if (perform_query) {
                let query = this.$route.query.q
                if (this.$route.query.genome_version) {
                    this.$store.dispatch('setGenomeVersion',this.$route.query.genome_version)
                }

                await variant_annotation.startRequestVariantList(query,this.$store.getters.getGenomeVersion)

                this.revel_key += 1
                this.$store.dispatch('setQuery',this.$route.query.q)
            }

            this.$store.dispatch('setBackRef',this.$route.fullPath)
        }
        else if (this.$route.query.id != null) {
            //await variant_annotation.analyzeVariantsSequential(this.$route)
            let q = '?id=' + this.$route.query.id
            let data_dir = "loc"

            // Update store values

            await variant_annotation.loadVariantTypes(q, data_dir=data_dir)

            this.$store.dispatch('setBackRef',this.$route.fullPath)

            if (this.$route.query.annotate != null) {
                //await variant_annotation.analyzeVariantsSequential(this.$route)
                //this.$store.dispatch('setBackRef',this.$route.fullPath)
            }
        }

        this.generateGeneNameLocations()
    },
}
</script>
<style>
.table-variants tr > td:first-child {
    border:1px solid #dddddd;
}
.tb-variants-col {
    padding:10px;
}
.tb-variants-col:hover {
    background-color: #FFFFFF;
}
.mdi-arrow-up-thin:hover{
    color:#3498db;
}
.mdi-arrow-down-thin:hover{
    color:#3498db;
}
a.router-link-active {
    border-bottom: 1px solid 3498db;
}
.flip_bar{
-moz-transform: scale(-1, 1);
-webkit-transform: scale(-1, 1);
-o-transform: scale(-1, 1);
-ms-transform: scale(-1, 1);
transform: scale(-1, 1);
}
</style>
